export default __webpack_public_path__ + "static/media/Metropolis-Medium.e71bda5d.woff2";